/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Stack } from "@mui/material";
import { productStatusStyle } from "@/src/components/ProductStatus/productStatusStyle";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

export type ProductStatusMetaProps = {
  product: AbstractCase
}

export default function ProductStatusMeta({ product }: ProductStatusMetaProps) {
  let responsibleLawyer: { title?: string; name?: string } | null = null;
  if (product.responsibleLawyer) {
    responsibleLawyer = {
      title: product.responsibleLawyer.gender === "male" ? "Ihr Anwalt:" : "Ihre Anwältin:",
      name: product.responsibleLawyer.fullName,
    };
  }

  return (
    <Box component={"dl"}>
      <Stack direction={"row"}>
        <Box component={"dt"}>Fallnummer:</Box>
        <Box component={"dd"} sx={productStatusStyle.descriptionListValue}>
          {product.reference}
        </Box>
      </Stack>
      {!!responsibleLawyer && (
        <Stack direction={"row"}>
          <Box component={"dt"}>{responsibleLawyer.title}</Box>
          <Box component={"dd"} sx={productStatusStyle.descriptionListValue}>
            {responsibleLawyer.name}
          </Box>
        </Stack>
      )}
    </Box>
  );
}
